export function clamp(value: number, minimum: number, maximum: number): number {
  if (maximum < minimum) return maximum;
  return Math.min(Math.max(value, minimum), maximum);
}
